import { render } from "./TodoCardEndEntrega.vue?vue&type=template&id=6c8d5801"
import script from "./TodoCardEndEntrega.vue?vue&type=script&lang=js"
export * from "./TodoCardEndEntrega.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__